import "vite/modulepreload-polyfill";
import "@/styles/auth-common.css";
import "@fontsource-variable/inter";

// Handle Turnstile for firewall bypass
function initializeTurnstile() {
  const turnstileContainer = document.getElementById("turnstile-container");
  const submitBtn = document.getElementById("submit-btn");
  const form = document.getElementById("turnstile-form");

  if (!turnstileContainer || !submitBtn || !form) {
    return;
  }

  if (window.turnstile) {
    window.turnstile.render("#turnstile-container", {
      sitekey: "0x4AAAAAABrWC8POBFndQnsz",
      callback: function (token) {
        let tokenInput = form.querySelector(
          'input[name="cf-turnstile-response"]'
        );
        if (!tokenInput) {
          tokenInput = document.createElement("input");
          tokenInput.type = "hidden";
          tokenInput.name = "cf-turnstile-response";
          form.appendChild(tokenInput);
        }
        tokenInput.value = token;

        submitBtn.disabled = false;
        submitBtn.click();
      },
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  if (document.getElementById("turnstile-container")) {
    if (window.turnstile) initializeTurnstile();
    else window.onloadTurnstileCallback = initializeTurnstile;
  }
});
